import { Box, Stack, Typography } from '@mui/material'
import { FC } from 'react'
import { getPxAsRem } from 'shared/utils'
import { FRONTEND_COMMANDS } from './commandHandlers'

const SEARCH_MODIFIERS = [
    {
        syntax: 'note:word',
        description: 'Search for candidates/searches with matching notes',
    },
    {
        syntax: 'note:"multiple words"',
        description: 'Search notes containing a phrase',
    },
]

export const CommandsHelp: FC = () => {
    return (
        <Box padding={getPxAsRem(16, 24)}>
            <Typography
                variant="body2"
                color="text.secondary"
                sx={{ marginBottom: 2 }}
            >
                Type to search across everything, or use a command:
            </Typography>
            <Stack spacing={1}>
                {FRONTEND_COMMANDS.map((cmd) => (
                    <Box
                        key={cmd.shortcut}
                        sx={{
                            display: 'flex',
                            alignItems: 'baseline',
                            gap: 1.5,
                        }}
                    >
                        <Typography
                            component="code"
                            sx={{
                                fontFamily: 'monospace',
                                fontSize: '0.8rem',
                                backgroundColor: 'action.hover',
                                padding: '2px 6px',
                                borderRadius: 1,
                                minWidth: '2.5rem',
                            }}
                        >
                            {cmd.shortcut}
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                            {cmd.description}
                        </Typography>
                    </Box>
                ))}
            </Stack>

            <Typography
                variant="body2"
                color="text.secondary"
                sx={{ marginTop: 3, marginBottom: 2 }}
            >
                Search modifiers:
            </Typography>
            <Stack spacing={1}>
                {SEARCH_MODIFIERS.map((mod) => (
                    <Box
                        key={mod.syntax}
                        sx={{
                            display: 'flex',
                            alignItems: 'baseline',
                            gap: 1.5,
                        }}
                    >
                        <Typography
                            component="code"
                            sx={{
                                fontFamily: 'monospace',
                                fontSize: '0.8rem',
                                backgroundColor: 'action.hover',
                                padding: '2px 6px',
                                borderRadius: 1,
                            }}
                        >
                            {mod.syntax}
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                            {mod.description}
                        </Typography>
                    </Box>
                ))}
            </Stack>
        </Box>
    )
}
